module.exports = __webpack_public_path__ + "static/media/148.adc16f37.png";